// ISDP CUSTOM: Dräger-branded 404. Replaces Backstage's default "dropped the mic"
// NotFoundErrorPage. Wired as the FlatRoutes catch-all (path="*") in App.tsx.
import { useNavigate } from 'react-router-dom';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { useLink } from '../common';
import { authMessages } from '../../i18n/auth';
import './NotFoundPage.css';

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const link = useLink();
  const { t } = useTranslationRef(authMessages);

  return (
    <div className="devhub-notfound">
      <div className="devhub-notfound__panel">
        <span className="devhub-notfound__code">404</span>
        <h1 className="devhub-notfound__title">{t('notFound.title')}</h1>
        <p className="devhub-notfound__desc">{t('notFound.desc')}</p>
        <div className="devhub-notfound__actions">
          <a
            className="devhub-notfound__btn devhub-notfound__btn--primary"
            {...link('/')}
          >
            <odx-icon name="core::home" size="sm" />
            {t('notFound.backHome')}
          </a>
          <button
            type="button"
            className="devhub-notfound__btn"
            onClick={() => navigate(-1)}
          >
            <odx-icon name="core::arrow-left" size="sm" />
            {t('notFound.goBack')}
          </button>
        </div>
      </div>
    </div>
  );
};
